import React from 'react';
import { Col, Row } from 'react-bootstrap';

import TextLink from '../../../../../commonComponents/TextLink/TextLink';
import WYSIWYG from '../../../../../commonComponents/WYSIWYG/WYSIWYG';
import { AI_TASK_STATUS } from '../../Header/constants/constants';

export class QuestionTextArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInitial: this.props.value,
      idInitial: this.props.selectedQuestion.id,
    };
  }

  render() {
    const { selectedQuestion } = this.props;
    const value1 = this.props.value === '' ? ' ' : this.props.value;
    const deletedByAdmin = selectedQuestion?.submit?.deletedBy === 'ADMIN';

    const suggestionInProgress =
      selectedQuestion?.aiSuggestionStatus === AI_TASK_STATUS.IN_PROGRESS;
    const isButtonDisabled =
      !this.props.selectedQuestion.id ||
      this.state.textInitial !== this.props.selectedQuestion.text ||
      suggestionInProgress;
    if (this.props.selectedQuestion.id) {
      if (this.state.idInitial !== this.props.selectedQuestion.id) {
        this.setState({
          idInitial: this.props.selectedQuestion.id,
          textInitial: this.props.value,
        });
      } else {
        if (
          this.props.isSaveQuestion &&
          this.state.idInitial === this.props.selectedQuestion.id
        )
          this.setState({
            textInitial: this.props.value,
          });
      }
    }
    return (
      <Row className="QuestionTextAreaContainer">
        {selectedQuestion?.submit && (
          <Col md={3}>
            <div
              style={{
                backgroundColor: !deletedByAdmin
                  ? selectedQuestion.status === 'Submitted'
                    ? 'orange'
                    : '#4dbd74'
                  : 'red',
              }}
              className="statusContainer"
            >
              {!deletedByAdmin ? selectedQuestion.status : 'Deleted by admin'}
            </div>
          </Col>
        )}
        <Col md={selectedQuestion?.submit ? 9 : 11}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ whiteSpace: 'pre-line' }}>{this.props.title}</div>
            {this.props.questionHistory.subbmitedBy && (
              <div style={{ whiteSpace: 'pre-line' }}>
                {this.props.questionHistory.subbmitedBy}
              </div>
            )}
            {this.props.questionHistory.createdBy && (
              <div style={{ whiteSpace: 'pre-line' }}>
                {this.props.questionHistory.createdBy}
              </div>
            )}
            <div style={{ whiteSpace: 'pre-line' }}>
              {this.props.creationQuestionDate}
            </div>
            {this.props.importInformation && (
              <div style={{ whiteSpace: 'pre-line' }}>
                {this.props.importInformation}
              </div>
            )}
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              {
                /* In the List and PDF views, only include the "improve question with AI" and
                "include further reading in ai suggestion" options when editing a question */
                this.props.selectedQuestion.id &&
                  this.props.canAISuggestion && (
                    <>
                      <div
                        className={`more-options-btn  ${isButtonDisabled ? 'disabledButton' : 'suggestion-btn'}`}
                        onClick={() => {
                          if (
                            !isButtonDisabled &&
                            this.state.textInitial !== ''
                          ) {
                            this.props.improveQuestionWithAi(
                              this.props.selectedQuestion.id,
                              this.props.selectedQuestion.chapter.id,
                            );
                          }
                        }}
                        title={
                          !isButtonDisabled
                            ? 'Improve question with AI'
                            : suggestionInProgress
                              ? 'Ai suggestion in progress'
                              : 'Unsaved changes'
                        }
                      >
                        <i className="fa fa-lightbulb-o" />
                      </div>
                      <div
                        className="more-options-btn include-further-reading-checkbox"
                        title="Select to include further reading in the context of suggestion"
                        data-test="more-text-button"
                      >
                        <label>
                          <input
                            onClick={() =>
                              this.props.onChangeIncludeNotesInSuggestion(
                                this.props.selectedQuestion,
                                !this.props.selectedQuestion
                                  .includeNotesInSuggestion,
                              )
                            }
                            type="checkbox"
                            checked={
                              this.props.selectedQuestion
                                .includeNotesInSuggestion
                            }
                            disabled={!this.props.editPermission}
                          />
                          Include further reading in ai suggestion
                        </label>
                      </div>
                    </>
                  )
              }
            </div>
          </div>
        </Col>
        <Col md={12} className="width100">
          {selectedQuestion &&
          !selectedQuestion.isPublished &&
          selectedQuestion.sourceQuestion ? (
            <div className="centeredTextLink">
              <TextLink
                text="View Live Question"
                onAction={() =>
                  this.props.loadPublishedQuestion(this.props.sourceQuestion)
                }
              />
            </div>
          ) : selectedQuestion &&
            !selectedQuestion.sourceQuestion &&
            selectedQuestion.isPublished ? (
            <div className="centeredTextLink">
              <TextLink
                text="View Editing Question"
                onAction={() => this.props.loadPublishedQuestion(null)}
              />
            </div>
          ) : null}

          <WYSIWYG
            onChange={this.props.onChangeQuestion}
            redBorder={this.props.redBorder}
            contentError={(this.props.contentErrors || []).length > 0}
            value={value1}
            disabled={this.props.isDisabled}
            modalSize
            showWarning={this.props.showWarning}
            allowedFormats={[
              ['bold', 'underline'],
              [{ script: 'sub' }, { script: 'super' }],
              ['formula'],
            ]}
            onImagePaste={this.props.onImagePaste}
          />
        </Col>
      </Row>
    );
  }
}
